exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--adornment__1Gjdl{border-width:0;border-style:solid;cursor:pointer}.styles--start__S7IBC{border-right-width:1px}.styles--end__18tME{border-left-width:1px}\n", ""]);

// exports
exports.locals = {
	"adornment": "styles--adornment__1Gjdl",
	"start": "styles--start__S7IBC",
	"end": "styles--end__18tME"
};